"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("../config/const");
/**
 * formal config object translator
 *
 * @param {Object} data - serialized data
 * */
function configModelTranslator(data) {
    var keys = Object.keys(const_1.configMappingModel);
    return keys.reduce(function (result, key) {
        var _a, _b;
        var layerArr = const_1.configMappingModel[key].layer.split('.');
        // at the root of object
        if (layerArr[0] === '')
            return Object.assign(result, (_a = {},
                _a[key] = data[key],
                _a));
        var value = layerArr
            .reduce(function (original, layer) { return original[layer]; }, data)[key];
        return Object.assign(result, (_b = {},
            _b[key] = value,
            _b));
    }, {});
}
exports.configModelTranslator = configModelTranslator;
//# sourceMappingURL=config_util.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/util/config_util.js